"use client";

import { useMutation, useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { apiClient, get, post, URL } from "@/_nucleo/api";
import { InclusaoFatura, SalvarFatura } from "@FN";

const BASE_PATH = URL.in.API_FINANCEIRO_INCLUSAO;

/**
 * GET - Busca faturas na API
 */
async function fetchFinanceiroFaturas(
  fornecedores?: string,
  dataInicial?: string,
  dataFinal?: string
): Promise<InclusaoFatura[]> {
  const params = new URLSearchParams();
  if (fornecedores && fornecedores.trim()) params.append("fornecedores", fornecedores);
  if (dataInicial && dataInicial.trim()) params.append("dataInicial", dataInicial);
  if (dataFinal && dataFinal.trim()) params.append("dataFinal", dataFinal);

  const { data } = await get<InclusaoFatura[]>(apiClient.internal, `${BASE_PATH}?${params.toString()}`);
  
  return data ?? [];
}


export function useFinanceiroFaturasInclusao(
  fornecedores: string,
  dataInicial: string,
  dataFinal: string,
  options?: Omit<UseQueryOptions<InclusaoFatura[]>, "queryKey" | "queryFn">
) {
  return useQuery<InclusaoFatura[]>({
    queryKey: ["financeiro", "inclusao", "faturas", fornecedores, dataInicial, dataFinal],
    queryFn: () => fetchFinanceiroFaturas(fornecedores, dataInicial, dataFinal),
    staleTime: 5 * 60 * 1000,
    enabled: false, // continua manual
    ...options
  });
}

/**
 * POST - Salva faturas na API
 */
const SALVAR_PATH = "rpws003/prefatura";
async function fetchSalvarFaturas(cBody: SalvarFatura): Promise<SalvarFatura> {
  const { data } = await post<SalvarFatura>(apiClient.production, SALVAR_PATH, cBody)
  return data ?? ({} as SalvarFatura)
}

export function useSalvarFaturas(
  options?: Omit<
    Parameters<typeof useMutation<SalvarFatura, Error, SalvarFatura>>[0],
    "mutationFn"
  >
) {
  return useMutation<SalvarFatura, Error, SalvarFatura>({
    mutationFn: (body) => fetchSalvarFaturas(body),
    ...options,
  })
}
